<section class="w-100prc padding-20px margin-right-1rem table-container">
  <!--Week selection form -->
  <section>
    <form [formGroup]="weekFormGroup">
      <mat-form-field class="w-100prc">
        <mat-label>Select Week</mat-label>
        <mat-select formControlName="week"
                    (selectionChange)="selectWeekChange($event?.value)">

          <mat-option *ngFor="let week of preConstructionWeeks" [value]="week?.weekId" matTooltip="{{ getWeekLabel(week) }}">
            {{ getWeekLabel(week) }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </form>
  </section>

  <div *ngIf="areProjectsInitializing" class="loading-spinner">
    <mat-progress-spinner diameter="25" mode="indeterminate"></mat-progress-spinner>
  </div>

  <!--Projects table -->
  <section>
    <h4>{{projectsTableTitle}}</h4>
    <div *ngIf="projectsOfSelectedWeek?.length === 0; else projectsAvailable">
      No projects available for the selected week
    </div>
    <ng-template #projectsAvailable>
      <table>
        <tr>
          <th>Project Name</th>
          <th>Project Manager</th>
          <th>Leading technology</th>
          <th class="th-sm">Weekly Update Saved</th>
        </tr>
        <tr *ngFor="let project of this.weeklyUpdateReportService?.projects">
          <td>
            {{project?.name}}
          </td>
         <td>
            {{getUser(project)?.fullName}}
          </td>
          <td>
            {{technologyToLabel[project?.leadingTechnology]}}
          </td>
          <td class="td-icon">
            <span *ngIf="getWeeklyUpdateReportProjectByProjectId(project?.projectId)?.weeklyUpdateProvided; else notProvided">
              <mat-icon matTooltip="Signed by: {{getSignedByUser(project?.projectId)?.fullName}}">
                check_circle_outline
              </mat-icon>
            </span>
            <ng-template #notProvided>
              <mat-icon>
                highlight_off
              </mat-icon>
            </ng-template>
          </td>
        </tr>
      </table>
    </ng-template>
  </section>
</section>
